module.exports = __webpack_public_path__ + "static/media/Prism layout.577d0ca3.sketch";